// Mock data for TechKila website

export const navigationLinks = [
  { id: 'home', label: 'HOME', href: '#home' },
  { id: 'about', label: 'ABOUT US', href: '#about' },
  { id: 'services', label: 'SERVICES', href: '#services' },
  { id: 'blogs', label: 'BLOGS', href: '#blogs' },
  { id: 'contact', label: 'CONTACT', href: '#contact' }
];

export const heroData = {
  tagline: 'DIGITAL PRODUCT | UIX SOLUTIONS | CONSULTANCY',
  title: 'Digital Solutions for Improving',
  highlight: 'Sales and Revenue',
  ctaText: 'GET STARTED',
  ctaLink: '#contact',
  backgroundImage: 'https://images.pexels.com/photos/7223039/pexels-photo-7223039.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
};

export const aboutData = {
  badge: '2',
  badgeLabel: 'YEARS',
  badgeSubLabel: 'EXPERIENCE',
  sectionLabel: 'About us',
  title: 'Amazing Result with TECHKILA.',
  subtitle: 'TechKila is obsessed with delivering measurable, jaw-dropping results',
  description: 'Our team brings years of hard-won experience across web design, SEO, content management, and digital marketing. We wield the latest technologies and elite strategies to secure your online success—because throwing spaghetti at the wall to see what sticks is a terrible marketing plan, and it ruins the wallpaper.',
  features: [
    'CORE LEVEL DESIGN',
    'PURE HAND WORK',
    'SOLID MATERIAL',
    '24/7 ONLINE SUPPORT'
  ],
  ctaText: 'LEARN MORE',
  ctaLink: '#services',
  image: 'https://images.pexels.com/photos/8127807/pexels-photo-8127807.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
};

export const servicesData = {
  sectionLabel: 'Services',
  title: 'Digital Agency Services',
  description: 'At TechKila, we are a full-service digital agency specializing in AI Prompting, SEO, branding, and custom website design. Our experts are fiercely passionate about scaling your business online—because the only thing we love more than flawless code is watching your competitors panic ;)',
  services: [
    {
      id: 1,
      icon: 'Share2',
      title: 'Social Media Engagement',
      description: 'Do you see some businesses ruling the entire web? This is all because of strategic social media engagement.',
      link: '#'
    },
    {
      id: 2,
      icon: 'Globe',
      title: 'Website Development',
      description: 'We are one of the remarkable and notable web development companies delivering top-notch solutions.',
      link: '#'
    },
    {
      id: 3,
      icon: 'Palette',
      title: 'Branding',
      description: 'Advertising smartly weighs much more than advertising heavily. We create impactful brand identities.',
      link: '#'
    },
    {
      id: 4,
      icon: 'Search',
      title: 'SEO Services',
      description: 'Videos are the trendiest marketing approach. Our SEO services help you rank higher and reach more customers.',
      link: '#'
    },
    {
      id: 5,
      icon: 'Megaphone',
      title: 'Digital Advertising',
      description: 'Advertising smartly weighs much more than advertising heavily. We run data-driven ad campaigns.',
      link: '#'
    },
    {
      id: 6,
      icon: 'PenTool',
      title: 'Content Writing',
      description: 'Content is king. Our expert writers create compelling content that engages and converts your audience.',
      link: '#'
    }
  ]
};

export const statsData = [
  { value: 200, suffix: '+', label: 'Active Users' },
  { value: 500, suffix: '+', label: 'Cup of Coffee' }
];

export const bridgingData = {
  title: 'Bridging',
  highlight: 'the Gap between Business and Technology',
  description: 'Closing the distance between traditional business and modern technology, we provide the foundation for growth and success in the digital era.',
  features: [
    {
      title: 'Strategic Planning',
      description: 'We work with you to develop a comprehensive digital marketing strategy tailored to your business. We understand the nuances of digital marketing and use our expertise to create an action plan that will get results.'
    },
    {
      title: 'Campaign Execution',
      description: "Once a strategy is in place, we'll execute it flawlessly. Our team has the experience and knowledge to make sure that your campaigns are successful and your goals are achieved."
    }
  ],
  badge: 'TK',
  badgeLabel: 'Business + Technology'
};

export const progressData = {
  sectionLabel: 'Business Progress',
  title: 'Pay for Qualified Traffic',
  description1: 'Stop funding digital experiments and invest in the proven expertise of TechKila. We deliver top-tier, scalable solutions designed to aggressively accelerate your business growth.',
  description2: 'Our seasoned professionals get it right the first time, ensuring you never pay for someone else\'s learning curve. Because good tech isn\'t cheap, and cheap tech usually ends with you frantically unplugging your router.',
  email: 'Techkila@zohomail.com',
  skills: [
    { name: 'GRAPHIC DESIGN', percentage: 85 },
    { name: 'APP DEVELOPMENT', percentage: 90 },
    { name: 'WEB DEVELOPMENT', percentage: 95 }
  ]
};

export const foundersData = {
  sectionLabel: 'Leadership',
  title: 'FOUNDERS',
  founders: [
    {
      id: 1,
      name: 'Nandan Pandey',
      role: 'Co-Founder',
      image: 'https://customer-assets.emergentagent.com/job_learning-code-hub/artifacts/s4e3ids1_WhatsApp%20Image%202026-03-17%20at%2010.00.47%20PM.jpeg'
    },
    {
      id: 2,
      name: 'Parth Sharma',
      role: 'Co-Founder',
      image: 'https://customer-assets.emergentagent.com/job_learning-code-hub/artifacts/k3d059va_WhatsApp%20Image%202026-03-26%20at%2010.43.59%20PM.jpeg'
    }
  ]
};

export const testimonialsData = {
  sectionLabel: 'WHAT CLIENTS SAY',
  title: 'Truly Clients Feedback',
  testimonials: [
    {
      id: 1,
      name: 'Rajesh Kumar',
      role: 'CEO, Digital Ventures',
      content: "Working with TechKila has been a game-changer for our business. Their innovative approach to digital marketing and web development helped us increase our online presence by 300%. The team's dedication, expertise, and timely delivery exceeded our expectations. I highly recommend TechKila for anyone looking to transform their digital strategy.",
      rating: 5
    },
    {
      id: 2,
      name: 'Priya Sharma',
      role: 'Marketing Director, StartupHub',
      content: "TechKila delivered exceptional results for our SEO and branding project. Within 3 months, we saw a 250% increase in organic traffic and significant improvement in our search rankings. Their strategic approach and attention to detail make them stand out in the industry. Truly professional and results-driven!",
      rating: 5
    },
    {
      id: 3,
      name: 'Amit Patel',
      role: 'Founder, EcomSolutions',
      content: "From website development to digital advertising campaigns, TechKila has been our trusted partner. They transformed our outdated website into a modern, user-friendly platform that has doubled our conversion rates. The team's creativity and technical expertise are unmatched. Best investment we've made!",
      rating: 5
    }
  ]
};

export const contactData = {
  phone: '+91 6265358305',
  phoneLabel: 'TALK WITH US',
  email: 'Techkila@zohomail.com',
  address: 'First floor building 9, cyber city, Gurugram, 122001'
};

export const footerData = {
  companyName: 'TechKila',
  description: 'Digital Solutions for Improving Sales and Revenue',
  copyright: '© 2025 TechKila. All rights reserved.',
  socialLinks: [
    { id: 'facebook', icon: 'Facebook', url: '#' },
    { id: 'twitter', icon: 'Twitter', url: '#' },
    { id: 'linkedin', icon: 'Linkedin', url: '#' },
    { id: 'instagram', icon: 'Instagram', url: '#' }
  ]
};